export default {
  myAssetLibrary: 'マイアセットライブラリ',
  cancel: 'キャンセル',
  confirm: '確認',
  continue: '続行',
  filter: {
    search: '検索',
    assetName: 'アセット名',
    assetId: 'アセットID',
    updateTime: '更新時間',
    createTime: '作成時間',
    format: 'フォーマット',
    type: 'タイプ',
    image: '画像',
    video: 'ビデオ',
    audio: '音声',
    h5: 'h5',
    psd: 'psd',
    font: 'フォント',
    zip: 'ZIPファイル',
    dragonbone: 'DragonBones',
    seqframe: 'シークエンス',
    screenRecordFile: '画面レコーディングアセットファイル',
    proportion: '比率',
    direction: '方向',
    horizontal: '横',
    vertical: '縦',
    square: 'スクエア',
    duration: '時間',
    second: '秒',
    minute: '分',
    hour: '時間',
    codeRate: 'ビットレート',
    fileSize: 'ファイルサイズ',
    size: '寸法',
    date: '日付',
    width: '幅',
    high: '高さ',
    widthSize: '幅',
    highSize: '高さ',
    other: 'その他',
    min: '最小',
    max: '最大',
    upload: 'アップロード',
    share: 'チーム共有',
    synchronization: 'システム同期',
    playturbo: 'Playturboで生成',
    source: 'アセットのソース',
    today: '今日',
    week: '過去1週間',
    searchSize: 'サイズ',
    createdate: '作成日',
    updatedate: '更新日',
  },
}
